export const locale = {
    'OFFER': {
        'STATUS': {
            'NOTACCEPTED': 'Not accepted',
            'IN_QUEUE': 'Queued',
            'DECLINED': 'Declined',
        },
    },
}
